import * as TypeGraphQL from "type-graphql";
export var ActionScalarFieldEnum;
(function (ActionScalarFieldEnum) {
    ActionScalarFieldEnum["id"] = "id";
    ActionScalarFieldEnum["sequence"] = "sequence";
    ActionScalarFieldEnum["tradeId"] = "tradeId";
    ActionScalarFieldEnum["type"] = "type";
    ActionScalarFieldEnum["primary"] = "primary";
    ActionScalarFieldEnum["note"] = "note";
    ActionScalarFieldEnum["status"] = "status";
    ActionScalarFieldEnum["createdAt"] = "createdAt";
    ActionScalarFieldEnum["updatedAt"] = "updatedAt";
    ActionScalarFieldEnum["alpacaOrderId"] = "alpacaOrderId";
})(ActionScalarFieldEnum || (ActionScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ActionScalarFieldEnum, {
    name: "ActionScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ActionScalarFieldEnum.js.map